// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Hold viewer specific css not inside theme
*/
.keyboard-focused {
  border: revert !important;
}

/* Work around to have border map container focus */
[class*='mapContainer'].keyboard-focused {
  border: #000 solid 2px !important;
}

.geoview-map {
  position: relative !important;
}

/* FIX: fix issue when overview map is added on resize.
        This is a patch and would better resolve managing the screen resize event and trap the control creation.
        Because it would not happen very often in production it may be a suitable patch. 
*/
.ol-overlaycontainer-stopevent .ol-overviewmap:not(:last-child) {
  display: none;
}
@media (max-width: 960px) {
  .ol-overviewmap {
    display: none;
  }
}

/* specifiv style for icon alignement in guide component */
.guideBox h3 img {
  vertical-align: bottom;
}
.guideBox h4 img {
  vertical-align: bottom;
}
.guideBox p img {
  vertical-align: bottom;
}

/* smooth data table scrolling */
.MuiTableContainer-root {
  contain: paint;
  will-change: transform;
}

/*
TODO Issue #3069: Is this needed? MuiGrid-container does not have a border by default
If this is to override a specific element it should be done there and not placed globally
the use of !important should also be used sparingly
 */
.MuiGrid-container:first-of-type {
  border: none !important;
}

/*
 * Accessibility: Visually hidden content for screen readers
 * 
 * This CSS class is required for HTML string contexts where sanitizeHtmlContent()
 * processes user-generated content.
 * 
 * Usage:
 * - CSS class: For HTML string manipulation (e.g., linkified content from external sources)
 * - JS object: For React components using sx prop (e.g., <Box sx={visuallyHidden}>)
 */
.visually-hidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip-path: inset(50%) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/ui/style/style.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;CAGC;AACD;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,0DAA0D;AAC1D;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;;EAIE;AACF;EACE,uBAAuB;AACzB;;AAEA;;;;;;;;;EASE;AACF;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;EAChC,8BAA8B;EAC9B,oBAAoB;AACtB","sourcesContent":["/*\nHold viewer specific css not inside theme\n*/\n.keyboard-focused {\n  border: revert !important;\n}\n\n/* Work around to have border map container focus */\n[class*='mapContainer'].keyboard-focused {\n  border: #000 solid 2px !important;\n}\n\n.geoview-map {\n  position: relative !important;\n}\n\n/* FIX: fix issue when overview map is added on resize.\n        This is a patch and would better resolve managing the screen resize event and trap the control creation.\n        Because it would not happen very often in production it may be a suitable patch. \n*/\n.ol-overlaycontainer-stopevent .ol-overviewmap:not(:last-child) {\n  display: none;\n}\n@media (max-width: 960px) {\n  .ol-overviewmap {\n    display: none;\n  }\n}\n\n/* specifiv style for icon alignement in guide component */\n.guideBox h3 img {\n  vertical-align: bottom;\n}\n.guideBox h4 img {\n  vertical-align: bottom;\n}\n.guideBox p img {\n  vertical-align: bottom;\n}\n\n/* smooth data table scrolling */\n.MuiTableContainer-root {\n  contain: paint;\n  will-change: transform;\n}\n\n/*\nTODO Issue #3069: Is this needed? MuiGrid-container does not have a border by default\nIf this is to override a specific element it should be done there and not placed globally\nthe use of !important should also be used sparingly\n */\n.MuiGrid-container:first-of-type {\n  border: none !important;\n}\n\n/*\n * Accessibility: Visually hidden content for screen readers\n * \n * This CSS class is required for HTML string contexts where sanitizeHtmlContent()\n * processes user-generated content.\n * \n * Usage:\n * - CSS class: For HTML string manipulation (e.g., linkified content from external sources)\n * - JS object: For React components using sx prop (e.g., <Box sx={visuallyHidden}>)\n */\n.visually-hidden {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip-path: inset(50%) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
